// IE polyfill for .matches method
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
window.focusToElement = (e, targetElem) => {
  if (e.key === 'Enter') {
    document.getElementById(targetElem).focus();
  }
};
function addActiveClass(el) {
  el.classList.add('is-active');
}
function removeActiveClass(el) {
  el.classList.remove('is-active');
}
// Finds the next instance of role="menu" right after the top level menuitem
function getNextMenu(elem) {
  let sibling = elem.nextElementSibling;
  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches('[role="menu"]')) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }
  return false;
}
function collapseSubMenu(topNav, subNav) {
  topNav.focus();
  topNav.setAttribute('aria-expanded', 'false');
  removeActiveClass(subNav);
}
// Function to advance cursor to next index of the menu array. It takes an event, an iterator, and an menu array
function focusNext(ev, i, items) {
  ev.preventDefault();
  if (i === items.length - 1) {
    items[0].focus();
  } else {
    items[i + 1].focus();
  }
}
function focusPrevious(ev, i, items) {
  ev.preventDefault();
  if (i === 0) {
    items[items.length - 1].focus();
  } else {
    items[i - 1].focus();
  }
}
// Search algo that returns the matching indexes of dropdown menu items and the character key from the user
function findChar(char, menuList) {
  const matchArr = [];
  for (let i = 0; i < menuList.length; i++) {
    // Get first letter of the menu item text
    const str = menuList[i].textContent;
    const cleanStr = str.trim().charAt(0).toLowerCase();
    // set user char set to lowercase
    const cleanChar = char.toLowerCase();
    // return the indexes of the matching list items
    if (cleanChar === cleanStr) {
      matchArr.push(i);
    }
  }
  return matchArr;
}
// magic function that takes: a THIS object, event, an empty array, and menu nodelist and advances to the next focus
// to the next list items with that same letter character
function advanceToNextChar(obj, charE, charKey, charMenuList) {
  const newObj = obj;
  // Temporarily save out previous keystroke to detect if it's been hit again directly in sequence
  charKey.push(charE.keyCode);
  // If the array is larger than two, remove the first item.
  if (charKey.length > 2) {
    charKey.shift();
  }
  // Find if any of the current menu list items match the first char search
  const keyMatches = findChar(charE.key, charMenuList);
  if (keyMatches[0] !== undefined) {
    // If the next character keystroke matches the previous one, go to next instance in the menu list
    if ((charKey[0] === charKey[1]) && (newObj.i < (keyMatches.length - 1))) {
      newObj.i++;
      charMenuList[keyMatches[newObj.i]].focus();
    } else {
      // Focuses on the first indexable match
      newObj.i = 0;
      charMenuList[keyMatches[newObj.i]].focus();
    }
  }
}
// If user hits downArrow, get the next sub-menu, open it, and focus into it
function activateDropMenu(e) {
  // Target next and previous top level nav items relative to current
  let nextTopLevelNavItem;
  let previousTopLevelNavItem;
  try {
    nextTopLevelNavItem = this.parentNode.nextElementSibling.querySelector('[aria-haspopup="true"]');
  } catch (error) {
    // The next type of sibling does not exist
  }
  try {
    previousTopLevelNavItem = this.parentNode.previousElementSibling.querySelector('[aria-haspopup="true"]');
  } catch (error) {
    // The previous type of sibling does not exist
  }
  // ArrowDown or Spacebar
  if ((e.key === 'ArrowDown') || (e.key === 'Down') || (e.keyCode === 32)) {
    e.preventDefault();
    // Adjust aria-expanded state on top level nav item when the drop menu opens
    this.setAttribute('aria-expanded', 'true');
    const subMenu = getNextMenu(this);
    // Open the sub-menu
    addActiveClass(subMenu);
    // Find all menuitems inside current menu
    const menuItem = subMenu.querySelectorAll('[role="menuitem"]');
    const secMenuItem = subMenu.querySelectorAll('.secondary-menu-item');
    menuItem[0].focus();
    // Setting/clearing the array for the charSearch each time the menu opens
    this.keyStroke = [];
    // loop through menuitems and set arrow functions to navigate through the loop
    for (let i = 0; i < secMenuItem.length; i++) {
      // If the loop has never run on this drop menu before, run it and append event listeners
      if (!secMenuItem[i].listenerAdded) {
        // If the menuitem is the parent of a tertiary submenu /////////////////////////////////////////////////// TERTIARY PARENT
        if (secMenuItem[i].classList.contains('tertiary-menu-parent')) {
          secMenuItem[i].addEventListener('keydown', (ev) => {
            // Right arrow should focus into that parents tertiary menu
            if ((ev.key === 'ArrowRight') || (ev.key === 'Right')) {
              ev.preventDefault();
              const tertMenu = getNextMenu(secMenuItem[i]);
              const tertMenuItem = tertMenu.querySelectorAll('.tertiary-menu-item');
              tertMenuItem[0].focus();
              // Setting/clearing the array for the charSearch each time the tertiary menu is entered
              this.tertKeyStroke = [];
              // For every tertiary menu item in THIS tertiary sub menu
              for (let x = 0; x < tertMenuItem.length; x++) {
                // Checks to see if this for loop has already run before. If so, no need to add duplicate listeners
                if (!tertMenuItem[x].listenerAdded) {
                  tertMenuItem[x].addEventListener('keydown', (evt) => {
                    // If the user pressed a character key, A - Z.
                    if ((evt.keyCode >= 65) && (evt.keyCode <= 90)) {
                      // magic function that takes: a THIS object, event, an empty array, and menu nodelist and advances to the next focus
                      advanceToNextChar(this, evt, this.tertKeyStroke, tertMenuItem);
                    }
                    // If youre in the tertiary submenu /////////////////////////////////////////////////// TERTIARY SUB MENU ITEM
                    // if arrow down, jump focus to next tertiary menu item
                    if ((evt.key === 'ArrowDown') || (evt.key === 'Down')) {
                      focusNext(evt, x, tertMenuItem);
                    }
                    // if arrow up, jump focus to previous submenu item.
                    if ((evt.key === 'ArrowUp') || (evt.key === 'Up')) {
                      focusPrevious(evt, x, tertMenuItem);
                    }
                    // Arrow Right if you are in the tertiary sub menu.
                    if ((evt.key === 'ArrowRight') || (evt.key === 'Right') || (evt.key === 'Tab')) {
                      evt.preventDefault();
                      collapseSubMenu(this, subMenu);
                      if (nextTopLevelNavItem) {
                        nextTopLevelNavItem.focus();
                      }
                    }
                    // Tertiary menu items should jump focus to previous parent secondary sub menu item when the user presses left arrowor ESC.
                    if ((evt.key === 'ArrowLeft') || (evt.key === 'Left') || (evt.key === 'Escape') || (evt.key === 'Esc')) {
                      evt.preventDefault();
                      secMenuItem[i].focus();
                    }
                    // If spacebar is clicked on tertiary menu item link
                    if (evt.keyCode === 32) {
                      evt.preventDefault();
                      tertMenuItem[x].click();
                    }
                    // If HOME is clicked on a secondary menu item link
                    if (evt.key === 'Home') {
                      evt.preventDefault();
                      tertMenuItem[0].focus();
                    }
                    // If END is clicked on a secondary menu item link
                    if (evt.key === 'End') {
                      evt.preventDefault();
                      tertMenuItem[tertMenuItem.length - 1].focus();
                    }
                  }, false);
                }
                tertMenuItem[x].listenerAdded = true;
              }
            }
          }, false);
        }
        // If the menuitem is an item in a secondary menuitem /////////////////////////////////////////////////// SECONDARY MENU ITEMS
        if (secMenuItem[i].classList.contains('secondary-menu-item')) {
          secMenuItem[i].addEventListener('keydown', (ev) => {
            // If the user pressed a character key, A - Z.
            if ((ev.keyCode >= 65) && (ev.keyCode <= 90)) {
              // magic function that takes: a THIS object, event, an empty array, and menu nodelist and advances to the next focus
              advanceToNextChar(this, ev, this.keyStroke, secMenuItem);
            }
            // if arrow down, jump focus to next submenu item
            if ((ev.key === 'ArrowDown') || (ev.key === 'Down')) {
              focusNext(ev, i, secMenuItem);
            }
            // if arrow up, jump focus to previous submenu item
            if ((ev.key === 'ArrowUp') || (ev.key === 'Up')) {
              focusPrevious(ev, i, secMenuItem);
            }
            // All secondary menyitems should jump focus to previous top level nav when the user presses left arrow
            if ((ev.key === 'ArrowLeft') || (ev.key === 'Left')) {
              ev.preventDefault();
              collapseSubMenu(this, subMenu);
              if (previousTopLevelNavItem) {
                previousTopLevelNavItem.focus();
              }
            }
            // If user hits TAB, advance to next parent menu item
            if (ev.key === 'Tab') {
              ev.preventDefault();
              collapseSubMenu(this, subMenu);
              if (nextTopLevelNavItem) {
                nextTopLevelNavItem.focus();
              }
            }
            if ((ev.key === 'Escape') || (ev.key === 'Esc')) {
              ev.preventDefault();
              collapseSubMenu(this, subMenu);
            }
            // If spacebar is clicked on a secondary menu item link
            if (ev.keyCode === 32) {
              ev.preventDefault();
              secMenuItem[i].click();
            }
            // If HOME is clicked on a secondary menu item link
            if (ev.key === 'Home') {
              ev.preventDefault();
              secMenuItem[0].focus();
            }
            // If END is clicked on a secondary menu item link
            if (ev.key === 'End') {
              ev.preventDefault();
              secMenuItem[secMenuItem.length - 1].focus();
            }
          }, false);
        }
        // All menuitems that are NOT the parent of a teriary submenu or tertiary submenu items ///////////////////////// SECONDARY MENU ITEMS, NOT TERTIARY PARENTS
        if ((!secMenuItem[i].classList.contains('tertiary-menu-parent'))) {
          // focuses on first menuitem in the now active dropdown submenu
          menuItem[0].focus();
          secMenuItem[i].addEventListener('keydown', (ev) => {
            // if arrow right, focus to next aria-haspopup and close current menu
            if ((ev.key === 'ArrowRight') || (ev.key === 'Right')) {
              ev.preventDefault();
              collapseSubMenu(this, subMenu);
              if (nextTopLevelNavItem) {
                nextTopLevelNavItem.focus();
              }
            }
            // Collapse submenu if Escape is pressed
            if ((ev.key === 'Escape') || (ev.key === 'Esc')) {
              collapseSubMenu(this, subMenu);
            }
          }, false);
        }
      }
      secMenuItem[i].listenerAdded = true;
    }
  }
}
// Take node list of has-popup=true elems (top level nav items), and append event listeners
function addMenuListener(items, func) {
  for (let i = 0; i < items.length; i++) {
    items[i].addEventListener('keydown', func, false);
  }
}
function addListenerTargets() {
  // Setting up targets for the event listeners
  const dropdownMenu = document.querySelectorAll('[aria-haspopup="true"]');
  const allMenus = document.querySelectorAll('[role="menu"]');
  // For dropdown menus
  addMenuListener(dropdownMenu, activateDropMenu);
  // Main menu items /////////////////////////////////////////////////////////////// MAIN MENU ITEMS ONLY
  // Char search for main menu items
  const mainNavItems = document.querySelectorAll('.main-menu-item');
  this.userKeyStroke = [];
  for (let i = 0; i < mainNavItems.length; i++) {
    if (!mainNavItems[i].listenerAdded) {
      // If the loop has never run on this drop menu before, run it and append event listeners
      mainNavItems[i].addEventListener('keydown', (evt) => {
        if ((evt.keyCode >= 65) && (evt.keyCode <= 90)) {
          advanceToNextChar(this, evt, this.userKeyStroke, mainNavItems);
        } else {
          // Clear (refresh) the key stroke array
          this.userKeyStroke = [];
        }
        // if arrow down, jump focus to next submenu item
        if ((evt.key === 'ArrowRight') || (evt.key === 'Right')) {
          focusNext(evt, i, mainNavItems);
        }
        // if arrow up, jump focus to previous submenu item
        if ((evt.key === 'ArrowLeft') || (evt.key === 'Left')) {
          focusPrevious(evt, i, mainNavItems);
        }
      }, false);
    }
    mainNavItems[i].listenerAdded = true;
  }

  // When the user starts clicking with the mouse, collapse the menus
  document.addEventListener('click', (e) => {
    for (let i = 0; i < allMenus.length; i++) {
      removeActiveClass(allMenus[i]);
    }
  });
}
window.addEventListener('load', addListenerTargets, false);
